import React, { useState } from 'react';

import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { Flex, BadgeWrapper } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import { Tooltip } from '@material-ui/core';
import { formatCypressTag } from 'common/utils/cypress.utils';
import _ from 'lodash';
import { localStorageService } from './views/CustomReport/custom-report.serivce';
import { calculateEllipsisAfter } from './Performance.service';

const NewTag = styled(Flex)`
  background-color: #ac98ff;
  width: 4rem;
  height: 1.9rem;
  border-radius: 4px;
  justify-content: center;
  position: absolute;
  left: 17rem;
  :hover {
    cursor: pointer;
  }
`;

const Tab = styled(Flex)`
  cursor: pointer;
  position: relative;
  :hover {
    background-color: ${getColor('zircon')};
  }
  ${({ selected }) =>
    selected
      ? `
      ::after {
        content: '';
        position: absolute;
        bottom: 1.4rem;
        left: 0;
        right: 0;
        height: 36%;
        border-left: 3px solid ${getColor('dodgerBlue')};}`
      : ''}
`;

const TabTitle = styled(Text)`
  ${({ selected }) => (selected ? `color: ${getColor('dodgerBlue')};` : '')}
`;

const TabContainer = styled(Flex)`
  :hover {
    background-color: ${getColor('zircon')};
  }
`;

const PinIcon = styled(Icon)`
  margin-right: 1.5rem;
  cursor: pointer;
  :hover {
    color: ${getColor('dodgerBlue', 0.8)} !important;
  }
`;

const LockIcon = styled(Icon)`
  margin-right: 0.5rem;
`;

export const DashboardTab = ({
  dashboardKey,
  selected,
  onClick,
  dashboardName,
  dashboardId,
  onPinDashboard,
  pinnedDashboards,
  isPublic,
  enablePin = true,
  badge,
  isCustomPmReport = null,
  isNew = false,
  containerWidth
}) => {
  const newTabsClicked = localStorageService().getNewTabsClicked();
  const showNewTag = !_.get(newTabsClicked, dashboardId, false);
  const cyDashboardKey = formatCypressTag(dashboardKey);
  const clickableCyDataTag = `${cyDashboardKey}-dashboard-sidebar-select`;

  const tooltipCyDataTag = `${cyDashboardKey}-dashboard-sidebar-tooltip`;

  const [isHover, setIsHover] = useState(false);
  const isPinned = pinnedDashboards.includes(dashboardId);
  const prepareOnPinDashboard = () => {
    if (pinnedDashboards.includes(dashboardId)) {
      onPinDashboard(pinnedDashboards.filter(id => id !== dashboardId));
    } else {
      onPinDashboard([...pinnedDashboards, dashboardId]);
    }
  };
  const ellipsisAfetr = calculateEllipsisAfter(containerWidth);

  return (
    <TabContainer
      width='100%'
      items='center'
      justify='justify-between'
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Tab
        key={dashboardKey}
        pl='small'
        pt='normal'
        data-cy={clickableCyDataTag}
        pb='normal'
        width='100%'
        selected={selected}
        onClick={onClick}
      >
        {badge && <BadgeWrapper margin='0 1rem 0 0'>{badge}</BadgeWrapper>}
        <Flex items='center'>
          {!isPublic && (
            <LockIcon
              name='LockClosed'
              color={selected ? 'dodgerBlue' : 'osloGray'}
              alpha='0.5'
              size='smaller'
            />
          )}

          <TabTitle
            size='large'
            ellipsisAfter={ellipsisAfetr}
            selected={selected}
          >
            {dashboardName}
          </TabTitle>
        </Flex>
      </Tab>
      {isNew && showNewTag && (
        <NewTag items='center' data-testid={`${dashboardKey}-new-tag`}>
          <Text color='white' size='medium' weight='bold'>
            NEW!
          </Text>
        </NewTag>
      )}
      {isHover && enablePin && (
        <Tooltip
          title={isPinned ? 'Unpin from top' : 'Pin to top'}
          placement='top'
          data-cy={tooltipCyDataTag}
        >
          <PinIcon
            name={isPinned ? 'UnPin' : 'Pinned'}
            color='nepal'
            size='smaller'
            onClick={prepareOnPinDashboard}
          />
        </Tooltip>
      )}
    </TabContainer>
  );
};

export default DashboardTab;
